var _style, _path, _circle, _line, _line2, _line3, _line4, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89.9 89.9",
    style: {
      enableBackground: "new 0 0 89.9 89.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.reminder0{fill:none;stroke:#3949ab;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.reminder1{fill:none;stroke:#D99A29;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reminder0",
    d: "M67,74.4c-6.2,4.6-13.8,7.4-22.1,7.4C24.6,81.8,8.1,65.3,8.1,45C8.1,24.6,24.6,8.1,45,8.1S81.8,24.6,81.8,45 c0,4.4-0.8,8.5-2.1,12.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "reminder0",
    cx: 45,
    cy: 45,
    r: 44
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "reminder0",
    x1: 45,
    y1: 13.3,
    x2: 45,
    y2: 19.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "reminder0",
    x1: 45,
    y1: 71.4,
    x2: 45,
    y2: 77.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "reminder0",
    x1: 12.2,
    y1: 46.1,
    x2: 18.3,
    y2: 46.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "reminder0",
    x1: 73.3,
    y1: 46.1,
    x2: 77.7,
    y2: 46.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "reminder1",
    points: "30.2,41.6 45,49.9 45,29.1 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.6af463c10601bd7ca415d20ec6a1750b.svg";
export { ForwardRef as ReactComponent };